<template>
  <div class="hello">
    <Navbar></Navbar>
    <Carousel></Carousel>
    <br />
    <Snakelist></Snakelist>
  </div>
</template>
<script>
import Navbar from "./navbar";
import Carousel from "./carousel";
import Snakelist from "./snakelist";
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    Carousel,
    Snakelist,
    Navbar
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>